import React, { FC } from 'react';
import { TertiaryCtaProps } from './tertiaryCta.types';
import { StyledTertiaryCta } from './tertiaryCta.styles';

const TertiaryCta: FC<TertiaryCtaProps> = ({ className, clickHandler, label, isSearchPage }) => {
  const clickTrackingLoc = isSearchPage ? 'Search Form' : '';
  return (
    <StyledTertiaryCta
      data-component-name="a-shop-TertiaryCta"
      data-testid="shop-TertiaryCta"
      type="button"
      className={`${className}`}
      onClick={clickHandler}
    >
      <span
        className="custom_click_track"
        {...{
          custom_click_track_value: `${clickTrackingLoc}|  ${label} button |internal`,
        }}
      >
        {label}
      </span>
    </StyledTertiaryCta>
  );
};

export default TertiaryCta;
